// Modules
import React, { ReactNode, useRef } from 'react'
import 'react-spring-bottom-sheet/dist/style.css'
import { use100vh } from 'react-div-100vh'

// Components
import { BottomSheetRef } from 'react-spring-bottom-sheet'
import { BottomSheetComponent, BottomSheetContainer, BottomSheetContainerOverlay } from './styles'

interface BottomSheetProps {
    isOpen: boolean
    children?: ReactNode
    onRequestClose?: () => void
}

export const BottomSheet = ({ children, isOpen, onRequestClose }: BottomSheetProps) => {
    const sheetRef = useRef<BottomSheetRef>()
    const height = use100vh() || 0

    return (
        <BottomSheetContainer height={height} isOpen={isOpen}>
            <BottomSheetContainerOverlay data-testid="bottom-sheet-overlay" height={height} isOpen={isOpen} onClick={onRequestClose} />
            <BottomSheetComponent
                blocking={false}
                data-testid="bottom-sheet"
                onClick={() => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    sheetRef?.current?.snapTo(({ maxHeight }: any) => maxHeight)
                }}
                onDismiss={onRequestClose}
                open={isOpen}
                scrollLocking={false}
                snapPoints={({ maxHeight }) => maxHeight}
            >
                {children}
            </BottomSheetComponent>
        </BottomSheetContainer>
    )
}
